module.exports = __webpack_public_path__ + "img/modalRecapSvg2024-en.9bab6516.svg";